import React, { useEffect, useState, useContext } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  InputNumber,
  Input,
  DatePicker,
  Button,
  message,
  Table,
  Modal,
} from "antd";
import { platformApi } from "../../../../../api";
import TextArea from "antd/lib/input/TextArea";
import { ContextAPI } from "../../../../../ContextAPI";
import {
  paymentDataJoi,
  advancedPaymentDataJoi,
} from "../../BookingRegisterJoi";
import {
  generateErrorObj,
  defaultToNull,
  formatValue,
} from "../../../../../utils";
import moment from "moment";
const { Text } = Typography;
const { Option } = Select;

const PaymentData = ({ form, validityRef, clearRef, data, open, editable, mode }) => {

  const [bookingAuthStatus, updateBookingAuthStatus] = useState(false);
  const [financierData, setFinancierData] = useState([]);
  const [allow, setAllow] = useState(true);
  const [finAllow, setFinAllow] = useState(true);
  const [hypothecationAllow, setHypothecationAllow] = useState(true); // New state for hypothecation visibility
  const [showLoanFields, setShowLoanFields] = useState(false); // New state for loan fields visibility
  const [errorObj, setErrorObj] = useState({});
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [denominations, setDenominations] = useState([]);
  const [denominationModalVisible, setDenominationModalVisible] = useState(false);

  const paymentData = [
    { id: "cash", name: "Cash" },
    { id: "finance", name: "Finance" },
  ];
  const loanData = [
    { id: "self", name: "Self" },
    { id: "companyAssist", name: "Company-Assisted" },
  ];
  const hypothecationData = [
    { id: true, name: "Yes" },
    { id: false, name: "No" },
  ];

  const [emiNums, setEmiNums] = useState([]);

  const [currentFinancer, setCurrentFinancer] = useState();
  const { loginCredintials } = useContext(ContextAPI);

  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const paymentColumns = [
    {
      title: "S.No",
      key: "serial",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Collected Amount",
      dataIndex: "collectedAmount",
      key: "collectedAmount",
      render: (text) => `₹${text}`,
    },
    {
      title: "Pending Amount",
      key: "pendingAmount",
      render: (_, record) => {
        const paymentsList = data.payments || [];
        const recordIndex = paymentsList.findIndex((p) => p.id === record.id);
        
        let accumulatedCollected = 0;
        for (let i = 0; i <= recordIndex; i++) {
          const p = paymentsList[i];
          if (p && p.status === "SUCCESS") {
            accumulatedCollected += Number(p.collectedAmount || 0);
          }
        }
        const totalBill = Number(record.billAmount || 0);
        const pending = Math.max(totalBill - accumulatedCollected, 0);
        return `₹${pending}`;
      },
    },
    {
      title: "Method",
      dataIndex: "method",
      key: "method",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Date",
      key: "paymentDate",
      render: (_, record) => {
        const dateVal = record.dateOfPayment || record.createdAt;
        return dateVal ? moment(dateVal).format("DD/MM/YYYY HH:mm") : "-";
      },
    },
    {
      title: "Collected By",
      key: "collectedBy",
      render: (_, record) => {
        const empName =
          record.collectedBy?.employeeName ||
          record.EmployeeProfile?.employeeName ||
          record.employee?.profile?.employeeName ||
          record.employee?.employeeName ||
          (typeof record.collectedBy === "string" ? record.collectedBy : null);
        if (!empName) return "-";
        return empName
          .toLowerCase()
          .split(" ")
          .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
          .join(" ");
      },
    },
  ];


  const recalculateNetReceivables = () => {
    const paymentMode = getFieldValue("paymentMode");
    const finalAmount = parseFloat(data.price?.finalAmount || 0);
    const exchangePrice = parseFloat(data.exchange?.vehiclePrice || 0);
    const baseAmount = finalAmount - exchangePrice;
    const downPayment = parseFloat(getFieldValue("downPayment") || 0);

    // Case 1: Cash → finalAmount - exchangePrice
    // Case 2: Finance + DP <= 0 → finalAmount - exchangePrice
    if (paymentMode === "cash" || downPayment <= 0) {
      return baseAmount;
    }

    // Case 3: Finance + DP > 0 → computed netRec formula
    const onRoadDiscount = parseFloat(data.price?.onRoadDiscount || 0);
    const accessories = parseFloat(data.price?.accessoriesTotalAfterDiscount || 0);
    const affidavit = parseFloat(data.price?.affidavit || 0);
    const TRcharges = parseFloat(data.price?.tempRegister || 0);
    const specialNoCharges = parseFloat(data.price?.specialNoCharges || 0);
    const hypothetication = parseFloat(data.price?.hp || 0);
    const numberPlate = parseFloat(data.price?.numberPlate || 0);

    return (
      accessories + affidavit + TRcharges + specialNoCharges +
      hypothetication + numberPlate + downPayment -
      (exchangePrice + onRoadDiscount)
    );
  };

  const filterMethod = (input, option) => {
    setAddFinancier(input);
    return (
      option.props.children
        .toString()
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  };
  const [addFinancier, setAddFinancier] = useState(null);

  useEffect(() => {
    let numArr = [];
    for (let i = 0; i < 28; i++) {
      let obj = {
        id: i + 1,
        name: i + 1,
      };
      numArr.push(obj);
    }

    setEmiNums(numArr);

    platformApi.get("/api/financer").then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setFinancierData(response.data);

          data.loan?.financer &&
            setCurrentFinancer(
              response.data.find((d) => d.id == data.loan?.financer.id)
            );
        }
      }
    });
  }, []);

  useEffect(() => {
    clearRef.current = () => {
      form.resetFields();
    };
    validityRef.current = () => {
      return validatePage();
    };
    return () => {
      validityRef.current = null;
      clearRef.current = null;
    };
  });

  useEffect(() => {
    updateBookingAuthStatus(
      (data.authentication && data.authentication.verifiedAt) || false
    );
    if (data.loan) {
      const shouldShowLoanFields = data.price.paymentMode === "finance";
      setShowLoanFields(shouldShowLoanFields);
      setFieldsValue({
        financerName: data.loan.financer && data.loan.financer.id,
        loan: String(data.loan.loanAmount || "0"),
        tenure: String(data.loan.tenure || "1"),
        downPayment: String(data.loan.downPayment || "0"),
        emiDate: data.loan.emiDate,
        emiStartDate: data.loan.emiStartDate
          ? moment(data.loan.emiStartDate)
          : null,
        paymentMode: data.price.paymentMode || "finance",
        loanType: data.loan.loanType,
        financerBranch: data.loan.financerBranch,
        netRecieveables: String(data.price.netRecieveables || "0"),
        emiAmount: String(data.loan.emiAmount || "0"),
        remarks: data.remarks,
        loanDis: String(data.loan.disbursementAmount || "0"),
        showroomFinanceCharges: String(data.loan.showroomFinanceCharges || "0"),
        hypothecation:
          data.loan.hypothecation !== undefined
            ? data.loan.hypothecation
            : false,
      });
      setAllow(data.price.paymentMode === "cash");
      setHypothecationAllow(data.price.paymentMode !== "finance");
      setFinAllow(
        !(
          data.loan.loanType === "companyAssist" &&
          data.price.paymentMode === "finance"
        )
      );

      // For Company-Assisted Finance: the updateNetReceivables() in VehicleData
      // uses (finalAmount - disbursementAmount) which ignores Exchange Price.
      // Immediately re-run addLoanDisAmount with the saved downPayment so that
      // Net Receivables is correctly computed (subtracting Exchange Price) the
      // moment this tab mounts — no manual Down Payment edit required.
      if (
        data.loan.loanType === "companyAssist" &&
        data.price.paymentMode === "finance"
      ) {
        addLoanDisAmount({
          target: { value: String(data.loan.downPayment || "0") },
        });
      }
    } else if (data.price) {
      const pMode = data.price.paymentMode || "cash";
      setFieldsValue({
        netRecieveables: String(data.price.netRecieveables !== undefined ? data.price.netRecieveables : "0"),
        paymentMode: pMode,
        remarks: data.remarks,
      });
      setAllow(pMode === "cash");
      setHypothecationAllow(pMode !== "finance");
      setShowLoanFields(pMode === "finance");
      setFinAllow(true);
    }
  }, [open]);

  const validatePage = () => {
    let isValid = false;
    form.validateFields((validationError) => {
      isValid = validationError === null;
      let paymentValidation;
      if (mode == "ConfirmBooking") {
        paymentValidation = paymentDataJoi(
          defaultToNull(form.getFieldsValue())
        );
      } else {
        paymentValidation = advancedPaymentDataJoi(
          defaultToNull(form.getFieldsValue())
        );
      }
      if (paymentValidation.error) {
        message.warning("Please enter valid data in the fields!");
        setErrorObj(generateErrorObj(paymentValidation, errorObj));
        isValid = false;
      }
    });
    if (isValid) {
      data.loan = {
        ...data.loan,
        financer: { id: getFieldValue("financerName") },
        financerBranch: getFieldValue("financerBranch"),
        loanAmount: getFieldValue("loan"),
        tenure: getFieldValue("tenure"),
        downPayment: getFieldValue("downPayment"),
        emiAmount: getFieldValue("emiAmount"),
        emiDate: getFieldValue("emiDate"),
        emiStartDate: getFieldValue("emiStartDate"),
        remarks: getFieldValue("remarks"),
        loanType: getFieldValue("loanType"),
        disbursementAmount: getFieldValue("loanDis"),
        showroomFinanceCharges: getFieldValue("showroomFinanceCharges"),
        hypothecation: getFieldValue("hypothecation"), // Include hypothecation in payload
      };
      (data.finName = currentFinancer && currentFinancer.name),
        (data.price = {
          ...data.price,
          paymentMode: getFieldValue("paymentMode"),
          netRecieveables: getFieldValue("netRecieveables"),
        });
      data.remarks = getFieldValue("remarks");
    }
    return isValid;
  };

  const addLoanDisAmount = (e) => {
    if (getFieldValue("loanType") !== "companyAssist") return;
    let downPayment = parseFloat(e.target.value === "" ? 0 : e.target.value);
    let exchangePrice = parseFloat(
      data.exchange && data.exchange.vehiclePrice ? data.exchange.vehiclePrice : 0
    );
    let finalAmount = parseFloat(data.price?.finalAmount || 0);
    let onRoadPrice = parseFloat(data.price?.onRoadPrice || 0);
    let showroomFinanceCharges = parseFloat(form.getFieldValue("showroomFinanceCharges") || 0);

    // DP <= 0: show baseAmount (finalAmount - exchangePrice)
    if (downPayment <= 0) {
      setFieldsValue({
        loanDis: String(onRoadPrice + showroomFinanceCharges),
        netRecieveables: String(finalAmount - exchangePrice),
      });
      return;
    }

    // DP > 0: use the netRec computed formula
    let onRoadDiscount = parseFloat(data.price?.onRoadDiscount || 0);
    let accessoriesTotalAfteDicount = parseFloat(
      data.price?.accessoriesTotalAfterDiscount || 0
    );
    let affidavitAmount = parseFloat(data.price?.affidavit || 0);
    let TRcharges = parseFloat(data.price?.tempRegister || 0);
    let specialNoCharges = parseFloat(data.price?.specialNoCharges || 0);
    let hypothetication = parseFloat(data.price?.hp || 0);
    let numberPlate = parseFloat(data.price?.numberPlate || 0);

    let res =
      accessoriesTotalAfteDicount +
      affidavitAmount +
      TRcharges +
      specialNoCharges +
      hypothetication +
      numberPlate +
      downPayment -
      (exchangePrice + onRoadDiscount);

    let LoanDisAmount = onRoadPrice + showroomFinanceCharges - downPayment;
    setFieldsValue({
      loanDis: String(LoanDisAmount),
      netRecieveables: String(res),
    });
  };
  const validateOnBlur = () => {
    let paymentValidation = paymentDataJoi(
      defaultToNull(form.getFieldsValue())
    );
    if (paymentValidation.error) {
      if (errorObj.loanDis) setErrorObj({ loanDis: errorObj.loanDis });
      else setErrorObj({});
      let generatedError = generateErrorObj(paymentValidation, {});
      setErrorObj((prev) => ({ ...prev, ...generatedError }));
    } else {
      setErrorObj({});
    }
  };

  // const resetBasedonPaymentMode = (cond) => {
  //   setFieldsValue({
  //     financerBranch: undefined,
  //     financerName: undefined,
  //     loanDis: "0",
  //     showroomFinanceCharges: "0",
  //     loan: "0",
  //     tenure: "1",
  //     downPayment: "0",
  //     emiAmount: "0",
  //     emiDate: 1,
  //     emiStartDate: null,
  //   });
  //   if (cond)
  //     setFieldsValue({
  //       loanType: undefined,
  //     });
  //   setErrorObj({});
  // };
  const resetBasedonPaymentMode = (cond, preserveFinancierData = false) => {
    const fieldsToReset = {
      loanDis: "0",
      showroomFinanceCharges: "0",
      loan: "0",
      tenure: "1",
      downPayment: "0",
      emiAmount: "0",
      emiDate: 1,
      emiStartDate: null,
    };

    // Only reset financier fields if not preserving data
    if (!preserveFinancierData) {
      fieldsToReset.financerBranch = undefined;
      fieldsToReset.financerName = undefined;
    }

    setFieldsValue(fieldsToReset);

    if (cond) {
      setFieldsValue({
        loanType: undefined,
      });
    }
    setErrorObj({});
  };

  return (
    <Form style={{ marginTop: "1%", marginBottom: "4%" }}>
      <Row type="flex" justify="space-between">
        <Col span={5}>
          <Form.Item required colon={false} label={<Text>Payment Mode</Text>}>
            {getFieldDecorator("paymentMode", {
              rules: [
                {
                  required: true,
                  message: "Payment Mode Required!",
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                onSelect={(id) => {
                  resetBasedonPaymentMode(true);
                  if (id === "cash") {
                    setAllow(true);
                    setHypothecationAllow(true);
                    setShowLoanFields(false);
                    setFieldsValue({
                      hypothecation: undefined,
                      netRecieveables: recalculateNetReceivables(),
                    });
                    setFinAllow(true);
                  } else if (id === "finance") {
                    setAllow(false);
                    setHypothecationAllow(false);
                    setShowLoanFields(true);
                    // DP starts at 0 → show baseAmount
                    const baseAmount = (data.price?.finalAmount || 0) - (data.exchange?.vehiclePrice || 0);
                    setFieldsValue({
                      netRecieveables: String(baseAmount),
                    });
                  }
                }}
                disabled={!editable || bookingAuthStatus}
                placeholder="Payment Mode"
              >
                {paymentData.map((data) => (
                  <Select.Option key={data.id}>{data.name}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            style={{ visibility: hypothecationAllow ? "hidden" : "visible" }}
            colon={false}
            label={<Text>Hypothecation</Text>}
            required={!hypothecationAllow && mode == "ConfirmBooking"}
          >
            {getFieldDecorator("hypothecation", {
              rules: [
                {
                  required:
                    !hypothecationAllow && mode == "ConfirmBooking"
                      ? true
                      : false,
                  message: "Hypothecation Required!",
                },
              ],
            })(
              // <Select
              //   showAction={["click", "focus"]}
              //   onSelect={(value) => {
              //     setFieldsValue({
              //       financerBranch: undefined,
              //       financerName: undefined,
              //       loanDis: "0",
              //       showroomFinanceCharges: "0",
              //       loan: "0",
              //       tenure: "1",
              //       downPayment: "0",
              //       emiAmount: "0",
              //       emiDate: 1,
              //       emiStartDate: null,
              //       loanType: undefined,
              //     });
              //     const newNetReceivables = recalculateNetReceivables();
              //     setFieldsValue({
              //       netRecieveables: String(newNetReceivables)
              //     });

              //     if (value === true && getFieldValue("loanType") === "companyAssist") {

              //       addLoanDisAmount({
              //         target: { value: getFieldValue("downPayment") || 0 },
              //       });
              //     }
              //   }}
              //   disabled={!editable || hypothecationAllow || bookingAuthStatus}
              //   placeholder="Hypothecation"
              // >
              //   {hypothecationData.map((data) => (
              //     <Select.Option key={data.id} value={data.id}>
              //       {data.name}
              //     </Select.Option>
              //   ))}
              // </Select>
              <Select
                showAction={["click", "focus"]}
                onSelect={(value) => {
                  // Preserve existing financier and loan data when changing hypothecation
                  const currentFinancerName = getFieldValue("financerName");
                  const currentFinancerBranch = getFieldValue("financerBranch");
                  const currentLoanDis = getFieldValue("loanDis");
                  const currentShowroomFinanceCharges = getFieldValue("showroomFinanceCharges");
                  const currentLoan = getFieldValue("loan");
                  const currentTenure = getFieldValue("tenure");
                  const currentDownPayment = getFieldValue("downPayment");
                  const currentEmiAmount = getFieldValue("emiAmount");
                  const currentEmiDate = getFieldValue("emiDate");
                  const currentEmiStartDate = getFieldValue("emiStartDate");
                  const currentLoanType = getFieldValue("loanType");

                  setFieldsValue({
                    financerBranch: currentFinancerBranch,
                    financerName: currentFinancerName,
                    loanDis: currentLoanDis,
                    showroomFinanceCharges: currentShowroomFinanceCharges,
                    loan: currentLoan,
                    tenure: currentTenure,
                    downPayment: currentDownPayment,
                    emiAmount: currentEmiAmount,
                    emiDate: currentEmiDate,
                    emiStartDate: currentEmiStartDate,
                    loanType: currentLoanType,
                  });

                  const newNetReceivables = recalculateNetReceivables();
                  setFieldsValue({
                    netRecieveables: String(newNetReceivables)
                  });

                  if (value === true && getFieldValue("loanType") === "companyAssist") {
                    addLoanDisAmount({
                      target: { value: getFieldValue("downPayment") || 0 },
                    });
                  }
                }}
                disabled={!editable || hypothecationAllow || bookingAuthStatus}
                placeholder="Hypothecation"
              >
                {hypothecationData.map((data) => (
                  <Select.Option key={data.id} value={data.id}>
                    {data.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row type="flex" justify="space-between">
        <Col span={5}>
          <Form.Item
            style={{ visibility: showLoanFields ? "visible" : "hidden" }}
            colon={false}
            label={<Text>Loan Type</Text>}
            required={showLoanFields && mode == "ConfirmBooking"}
          >
            {getFieldDecorator("loanType", {
              rules: [
                {
                  required:
                    showLoanFields && mode == "ConfirmBooking" ? true : false,
                  message: "Loan Type Required!",
                },
              ],
            })(
              // <Select
              //   showAction={["click", "focus"]}
              //   onSelect={(id) => {
              //     resetBasedonPaymentMode(false);
              //     id === "self" ? setFinAllow(true) : setFinAllow(false);

              //     if (id === "self") {
              //       setFieldsValue({
              //         netRecieveables: recalculateNetReceivables(),
              //       });
              //     } else {
              //       setFieldsValue({
              //         netRecieveables: "0",
              //       });
              //     }

              //     id === "self" ? delete errorObj.financerBranch : null;
              //   }}
              //   disabled={!editable || !showLoanFields || bookingAuthStatus}
              //   placeholder="Loan Type"
              // >
              //   {loanData.map((data) => (
              //     <Select.Option key={data.id}>{data.name}</Select.Option>
              //   ))}
              // </Select>
              <Select
                showAction={["click", "focus"]}
                onSelect={(id) => {
                  // Preserve financier data when switching loan types
                  const currentFinancerName = getFieldValue("financerName");
                  const currentFinancerBranch = getFieldValue("financerBranch");

                  resetBasedonPaymentMode(false, true); // Pass true to preserve financier data

                  // Restore financier data if switching from one loan type to another
                  if (currentFinancerName && id === "self") {
                    setFieldsValue({
                      financerName: currentFinancerName,
                      financerBranch: currentFinancerBranch,
                    });
                  }

                  id === "self" ? setFinAllow(true) : setFinAllow(false);

                  if (id === "self") {
                    // Self loan + DP = 0 → baseAmount
                    const baseAmount = (data.price?.finalAmount || 0) - (data.exchange?.vehiclePrice || 0);
                    setFieldsValue({
                      netRecieveables: String(baseAmount),
                    });
                  } else {
                    // companyAssist: DP resets to 0 → show baseAmount
                    const baseAmount = (data.price?.finalAmount || 0) - (data.exchange?.vehiclePrice || 0);
                    setFieldsValue({
                      netRecieveables: String(baseAmount),
                    });
                  }

                  id === "self" ? delete errorObj.financerBranch : null;
                }}
                disabled={!editable || !showLoanFields || bookingAuthStatus}
                placeholder="Loan Type"
              >
                {loanData.map((data) => (
                  <Select.Option key={data.id}>{data.name}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            style={{ visibility: showLoanFields ? "visible" : "hidden" }}
            colon={false}
            label={<Text>Financier Name</Text>}
            required={showLoanFields && mode == "ConfirmBooking"}
          >
            <Row type="flex" justify="space-between" gutter={8}>
              <Col span={
                !(
                  addFinancier === null ||
                  financierData.some((financier) =>
                    financier.name
                      .toLowerCase()
                      .includes(addFinancier.toLowerCase())
                  )
                )
                  ? 18
                  : 24
              }>
                {getFieldDecorator("financerName", {
                  rules: [
                    {
                      required:
                        showLoanFields &&
                        (mode == "ConfirmBooking" ? true : false),
                      message: "Financier Name Required!",
                    },
                  ],
                })(
                  <Select
                    disabled={!editable || !showLoanFields || bookingAuthStatus}
                    showSearch
                    showAction={["click", "focus"]}
                    placeholder="Financier"
                    optionFilterProp="children"
                    filterOption={filterMethod}
                    style={{ width: "100%" }}
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ minWidth: 360 }}
                    onChange={(d) => {
                      setCurrentFinancer(financierData.find((j) => j.id == d));
                    }}
                  >
                    {financierData.map((data) => (
                      <Option key={data.id} value={data.id} title={data.name}>
                        {data.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Col>
              {!(
                addFinancier === null ||
                financierData.some((financier) =>
                  financier.name
                    .toLowerCase()
                    .includes(addFinancier.toLowerCase())
                )
              ) && (
                  <Col span={6}>
                    <Button
                      disabled={!editable || bookingAuthStatus}
                      onClick={() => {
                        if (addFinancier != null) {
                          platformApi
                            .post("/api/financer/", {
                              name: addFinancier,
                            })
                            .then((res) => {
                              setFinancierData([
                                ...financierData,
                                res.data.response.data,
                              ]);
                              form.setFieldsValue({
                                financierName: res.data.response.data.id,
                              });
                              message.success("Financier Added");
                              setAddFinancier(null);
                            });
                        }
                      }}
                      type="primary"
                    >
                      Add
                    </Button>
                  </Col>
                )}
            </Row>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            style={{ visibility: showLoanFields ? "visible" : "hidden" }}
            colon={false}
            required={
              showLoanFields && (mode == "ConfirmBooking" ? true : false)
            }
            label={<Text>Financier Branch</Text>}
          >
            {getFieldDecorator("financerBranch", {
              rules: [
                {
                  required:
                    showLoanFields && (mode == "ConfirmBooking" ? true : false),
                  message: "Financier Branch Required!",
                },
              ],
            })(
              <Input
                disabled={!editable || !showLoanFields || bookingAuthStatus}
                placeholder="Financier Branch"
                onKeyUp={(e) =>
                  form.setFieldsValue({
                    financerBranch: formatValue(e, "allCaps", true),
                  })
                }
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <br />
      <div
        style={{
          border: "1px solid gray",
          borderRadius: "1%",
          padding: "1%",
          visibility: finAllow ? "hidden" : "visible",
        }}
      >
        <Text strong>Financial Assistance Data</Text>
        <Row type="flex" justify="space-between">
          <Col span={7}>
            <Form.Item
              colon={false}
              label={<Text>Down Payment</Text>}
              validateStatus={errorObj && errorObj.downPayment ? "error" : ""}
              help={errorObj && errorObj.downPayment}
              required={!finAllow && mode == "ConfirmBooking"}
            >
              {getFieldDecorator("downPayment", {
                rules: [
                  {
                    required: !finAllow && (mode == "ConfirmBooking" ? true : false),
                    message: "Enter Down Payment!",
                  },
                ],
              })(
                <Input
                  addonBefore="&#8377;"
                  onKeyUp={(e) => {
                    let value = formatValue(e, "noWithDot");
                    // Remove leading zeros
                    value = value.replace(/^0+/, '');
                    if (value === '') value = '0';
                    form.setFieldsValue({
                      downPayment: value,
                    });
                  }}
                  disabled={!editable || allow || bookingAuthStatus}
                  placeholder="Down Payment"
                  onBlur={(e) => {
                    validateOnBlur(), addLoanDisAmount(e);
                  }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              colon={false}
              label={<Text>Tenure</Text>}
              validateStatus={errorObj && errorObj.tenure ? "error" : ""}
              help={errorObj && errorObj.tenure}
              required={!finAllow && mode == "ConfirmBooking"}
            >
              {getFieldDecorator("tenure", {
                rules: [
                  {
                    required:
                      !finAllow && (mode == "ConfirmBooking" ? true : false),
                    message: "Enter Tenure!",
                  },
                ],
              })(
                <Input
                  disabled={!editable || allow || bookingAuthStatus}
                  placeholder="Tenure (in Months)"
                  onKeyUp={(e) =>
                    form.setFieldsValue({
                      tenure: formatValue(e, "onlyNo"),
                    })
                  }
                  onBlur={() => validateOnBlur()}
                />
              )}
            </Form.Item>
          </Col>

          <Col span={7}>
            <Form.Item
              colon={false}
              label={<Text>Loan Amount</Text>}
              validateStatus={errorObj && errorObj.loan ? "error" : ""}
              help={errorObj && errorObj.loan}
              required={!finAllow && mode == "ConfirmBooking"}
            >
              {getFieldDecorator("loan", {
                rules: [
                  {
                    required: !finAllow && (mode == "ConfirmBooking" ? true : false),
                    message: "Enter Loan Amount!",
                  },
                ],
              })(
                <Input
                  addonBefore="&#8377;"
                  onKeyUp={(e) => {
                    let value = formatValue(e, "noWithDot");
                    // Remove leading zeros
                    value = value.replace(/^0+/, '');
                    if (value === '') value = '0';
                    form.setFieldsValue({
                      loan: value,
                    });
                  }}
                  disabled={!editable || allow || bookingAuthStatus}
                  placeholder="Loan Amount"
                />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row type="flex" justify="space-between">
          <Col span={7}>
            <Form.Item
              validateStatus={errorObj && errorObj.emiAmount ? "error" : ""}
              help={errorObj && errorObj.emiAmount}
              colon={false}
              label={<Text>EMI Amount</Text>}
              required={!finAllow && mode == "ConfirmBooking"}
            >
              {getFieldDecorator("emiAmount", {
                rules: [
                  {
                    required: !finAllow && (mode == "ConfirmBooking" ? true : false),
                    message: "Enter Emi Amount!",
                  },
                ],
              })(
                <Input
                  addonBefore="&#8377;"
                  onKeyUp={(e) => {
                    let value = formatValue(e, "noWithDot");
                    // Remove leading zeros
                    value = value.replace(/^0+/, '');
                    if (value === '') value = '0';
                    form.setFieldsValue({
                      emiAmount: value,
                    });
                  }}
                  disabled={!editable || allow || bookingAuthStatus}
                  placeholder="EMI Amount"
                  onBlur={() => validateOnBlur()}
                />
              )}
            </Form.Item>
          </Col>


          <Col span={7}>
            <Form.Item
              colon={false}
              label={<Text>EMI Date - Day Only</Text>}
              required={!finAllow && mode == "ConfirmBooking"}
            >
              {getFieldDecorator("emiDate", {
                rules: [
                  {
                    required:
                      !finAllow && (mode == "ConfirmBooking" ? true : false),
                    message: "Enter Emi Date!",
                  },
                ],
              })(
                <Select
                  showAction={["click", "focus"]}
                  disabled={!editable || allow || bookingAuthStatus}
                  placeholder="EMI Date - Day Only"
                >
                  {emiNums.map((data) => (
                    <Select.Option key={data.id}>{data.name}</Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              colon={false}
              label={<Text>EMI Start Date</Text>}
              required={!finAllow && mode == "ConfirmBooking"}
            >
              {getFieldDecorator("emiStartDate", {
                rules: [
                  {
                    required:
                      !finAllow && (mode == "ConfirmBooking" ? true : false),
                    message: "Enter Emi Start Date!",
                  },
                ],
              })(
                <DatePicker
                  style={{ width: "100%" }}
                  disabled={!editable || allow || bookingAuthStatus}
                  placeholder="EMI Start Date"
                  format="DD/MM/YYYY"
                  disabledDate={(current) => {
                    return (
                      (current && current < moment().startOf("day")) ||
                      current > moment(new Date()).add(2, "M")
                    );
                  }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span={7}>
            <Form.Item
              validateStatus={errorObj && errorObj.loanDis ? "error" : ""}
              help={errorObj && errorObj.loanDis}
              colon={false}
              label={<Text>Loan Disbursement Amount</Text>}
              required={!finAllow && mode == "ConfirmBooking"}
            >
              {getFieldDecorator("loanDis", {
                rules: [
                  {
                    required: !finAllow && (mode == "ConfirmBooking" ? true : false),
                    message: "Enter Loan Disbursement Amount!",
                  },
                ],
              })(
                <Input
                  disabled={true}
                  addonBefore="&#8377;"
                  onKeyUp={(e) => {
                    let value = formatValue(e, "noWithDot");
                    // Remove leading zeros
                    value = value.replace(/^0+/, '');
                    if (value === '') value = '0';
                    form.setFieldsValue({
                      loanDis: value,
                    });
                  }}
                  placeholder="Loan Disbursement Amount"
                  onBlur={() => validateOnBlur()}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={7} style={{ display: "none" }}>
            <Form.Item
              validateStatus={
                errorObj && errorObj.showroomFinanceCharges ? "error" : ""
              }
              help={errorObj && errorObj.showroomFinanceCharges}
              colon={false}
              label={<Text>Showroom Finance Charges</Text>}
              required={false}
            >
              {getFieldDecorator("showroomFinanceCharges", {
                rules: [
                  {
                    required: false,
                  },
                ],
              })(
                <Input
                  disabled={!editable || allow || bookingAuthStatus}
                  placeholder="Enter Showroom Finance"
                  onKeyUp={(e) => {
                    let value = formatValue(e, "noWithDot");
                    // Remove leading zeros
                    value = value.replace(/^0+/, '');
                    if (value === '') value = '0';
                    form.setFieldsValue({
                      showroomFinanceCharges: value,
                    });
                  }}
                  onBlur={() => {
                    validateOnBlur(),
                      addLoanDisAmount({
                        target: {
                          value: form.getFieldValue("downPayment") || 0,
                        },
                      });
                  }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </div>
      <Form.Item colon={false} label={<Text>Remarks</Text>}>
        {getFieldDecorator("remarks")(
          <TextArea
            disabled={!editable || bookingAuthStatus}
            rows={4}
            placeholder="Remarks"
            onKeyUp={(e) => {
              // Allow alphanumeric, spaces, and basic punctuation
              const value = e.target.value.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
              form.setFieldsValue({
                remarks: value,
              });
            }}
            onInput={(event) => {
              // Filter out special characters as user types
              const filteredValue = event.target.value.replace(/[^a-zA-Z0-9\s\-.,/]/g, '');
              if (filteredValue !== event.target.value) {
                event.target.value = filteredValue;
                form.setFieldsValue({
                  remarks: filteredValue,
                });
              }
            }}
          />
        )}
      </Form.Item>
      {data.payments && data.payments.length > 0 && (
        <div style={{ marginTop: "2%", marginBottom: "2%" }}>
          <Text strong>Receipt</Text>
          <Table
            dataSource={data.payments.map((p) => ({ ...p, key: p.id }))}
            columns={paymentColumns}
            pagination={false}
            bordered
            size="small"
            onRow={(record) => ({
              onClick: async () => {
                setSelectedPayment(record);
                setDenominationModalVisible(true);

                try {
                  const res = await platformApi.get(`/api/payment/getOne/${record.id}`);
                  if (res.data.code === 200 && res.data.response.code === 200) {
                    setDenominations(res?.data?.response?.data?.denominations);
                  } else {
                    message.warning("No denominations found for this payment");
                    setDenominations([]);
                  }
                } catch (error) {
                  console.error(error);
                  message.error("Failed to load denominations");
                }
              },
            })}
          />
        </div>
      )}
      <Form.Item
        style={{ marginLeft: "auto", width: "20%" }}
        colon={false}
        label={<Text>Net Receivables</Text>}
      >
        {getFieldDecorator("netRecieveables")(
          <Input addonBefore="&#8377;" disabled={true} placeholder="Total" />
        )}
      </Form.Item>
      {denominationModalVisible && (
        <Modal
          title={`Denominations for Payment`}
          visible={denominationModalVisible}
          onCancel={() => setDenominationModalVisible(false)}
          footer={null}
        >
          <Table
            dataSource={denominations.map((d, index) => ({
              ...d,
              key: index,
            }))}
            columns={[
              { title: "Denomination", dataIndex: "denomination", key: "denomination" },
              { title: "Count", dataIndex: "count", key: "count" },
              {
                title: "Transaction Type",
                dataIndex: "transactionType",
                key: "transactionType",
                render: (type) => (
                  <span
                    style={{
                      color: type === "CREDIT" ? "green" : "red",
                      fontWeight: 600,
                    }}
                  >
                    {type}
                  </span>
                ),
              },
              {
                title: "Total",
                key: "total",
                render: (text, record) => `₹${record.denomination * record.count}`,
              },
            ]}
            pagination={false}
            bordered
            size="small"
          />
        </Modal>
      )}
    </Form>
  );
};

const WrappedPaymentData = Form.create()(PaymentData);

export default WrappedPaymentData;